import { render, staticRenderFns } from "./appointmentResult.vue?vue&type=template&id=228736f3&scoped=true&"
import script from "./appointmentResult.vue?vue&type=script&lang=js&"
export * from "./appointmentResult.vue?vue&type=script&lang=js&"
import style0 from "./appointmentResult.vue?vue&type=style&index=0&id=228736f3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228736f3",
  null
  
)

export default component.exports